<template>
  <v-container fill-height justify-start fluid class="pa-0">
    <v-layout xs12 row wrap>
      <v-flex xs2 class="pa-0">
          <v-dialog
            class="pa-0"
            ref="dialogStartDate"
            persistent
            v-model="modalStartDate"
            lazy
            full-width
            width="290px"
            :return-value.sync="startDate"
          >
            <v-text-field
              slot="activator"
              label="Start Date"
              v-model="startDate"
              readonly
              @change="$v.startDate.$touch()"
              @blur="$v.startDate.$touch()"
            ></v-text-field>
            <v-date-picker
              v-model="startDate"
              scrollable
              :title-date-format="formatTitle"
              :max="endDate"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modalStartDate = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialogStartDate.save(startDate)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
      </v-flex>
      <v-flex xs2>
          <v-dialog
            ref="dialogEndDate"
            persistent
            v-model="modalEndDate"
            lazy
            full-width
            width="290px"
            :return-value.sync="endDate"
          >
            <v-text-field
              slot="activator"
              label="End Date"
              v-model="endDate"
              readonly
              @change="$v.endDate.$touch()"
              @blur="$v.endDate.$touch()"
            ></v-text-field>
            <v-date-picker
              v-model="endDate"
              scrollable
              :title-date-format="formatTitle"
              :max="maxDate"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modalEndDate = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialogEndDate.save(endDate)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
      </v-flex>
      <v-flex xs2>
          <v-dialog
            ref="dialogRVDate"
            persistent
            v-model="modalRVDate"
            lazy
            full-width
            width="290px"
            :return-value.sync="rvDate"
          >
            <v-text-field
              slot="activator"
              label="Date = 100"
              v-model="rvDate"
              readonly
              @change="$v.rvDate.$touch()"
              @blur="$v.rvDate.$touch()"
            ></v-text-field>
            <v-date-picker
              v-model="rvDate"
              scrollable
              :max="maxDate"
              :title-date-format="formatTitle"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modalRVDate = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialogRVDate.save(rvDate)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
      </v-flex>
      <v-flex xs1>
        <v-btn
          @click="redraw()"
           color="info"
        >Redraw</v-btn>
      </v-flex>
      <v-flex class="pa-0">
        <line-plot
          v-if="isDataReady"
          :ts="selectedTs"
          :params="plotParams"
          :id="getParentId"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import constants from '@/constants'
import TS from '@/classes/TS.class'
import TSS from '@/classes/TSS.class'
import tsfunctions from '@/lib/tsfunctions'
import DateLinePlot from '@/components/D3/DateLinePlot'

export default {
  mixins: [validationMixin],

  components: {
    'line-plot': DateLinePlot
  },
  data () {
    return {
      plotParams: {
        useDots: false,
        xlabel: 'Dates',
        ylabel: 'Relative Value',
        title: 'Universe of Securities by Relative Value',
        useLegend: true,
        legBorder: true,
        parentId: 'uni_vami_',
        // margins: {top: 20, right: 20, bottom: 20, left: 20}
        useFreqCtrl: true,
        useDotLabels: true
      },
      query: {
        frequency: 'm',
        columns: ['padjClose']
      },
      combine: { combine: true, keys: undefined, discard: false, pad: null },
      modalStartDate: false,
      startDate: null,
      modalEndDate: false,
      endDate: null,
      modalRVDate: false,
      rvDate: null
    }
  },

  validations: {
    startDate: { required },
    endDate: { required },
    rvDate: { required }
  },

  created () {
    // this changes when latest date implemented
    this.endDate = new Date().toISOString().slice(0, 10)
    console.log('created: this.endDate', this.endDate)
  },

  mounted () {
    console.log('UniVami:mount run')
    this.startDate = this.model.startDate
    this.endDate = new Date().toISOString().slice(0, 10)
    console.log('mounted: this.endDate', this.endDate)

    this.query.startDate = this.startDate
    this.query.endDate = this.endDate

    console.log('setting configs now')
    const config = {
      id: this.getParentId,
      query: this.query,
      tickers: this.modelTickers
    }
    this.setConfig(config)
    this.applyConfigPrices(config)
    this.startDate = this.model.startDate
    if (this.model.startDate !== null) {
      // this.endDate = new Date(this.model.endDate)
      this.endDate = this.model.endDate
    }
    this.rvDate = this.model.startDate
  },

  watch: {
    selectedTs: function (val) {
      // console.log('watch:selectedTs: val', val)
      if (val !== undefined) {
        this.endDate = val.endDate()
        this.query.endDate = this.endDate
      }
    },
    startDate: function (val) {
      this.query.startDate = val
    },
    endDate: function (val) {
      this.query.endDate = val
    },
    rvDate: function (val) {
      console.log('watch:rvDate: val', val)
      if (val !== undefined) {
        this.plotParams.ylabel = val + ' = 100'
      }
    }
  },
  computed: {
    ...mapGetters({
      getProp: 'getProp',
      getConfig: 'chart/getConfig',
      getConfigs: 'chart/getConfigs',
      model: 'models/model',
      getModelId: 'models/getModelId',
      modelPositions: 'models/modelPositions',
      selectedPrices: 'prices/selectedPrices',
      isPriceUpdated: 'prices/isPriceUpdated'
    }),
    startDateErrors () {
      const errors = []
      if (!this.$v.startDate.$dirty) return errors
      !this.$v.startDate.required && errors.push('A start date is required')
      return errors
    },
    endDateErrors () {
      const errors = []
      if (!this.$v.endDateErrors.$dirty) return errors
      !this.$v.endDateErrors.required && errors.push('An end date is required')
      return errors
    },
    rvDateErrors () {
      const errors = []
      if (!this.$v.rvDate.$dirty) return errors
      !this.$v.rvDate.required && errors.push('A relative value date is required')
      return errors
    },
    getParentId () {
      return this.plotParams.parentId + this.getModelId
    },
    modelTickers () {
      const tickers = []
      for (const ticker in this.modelPositions) {
        if (ticker !== constants.cashTicker) {
          tickers.push(ticker)
        }
      }
      return tickers
    },
    selectedTs () {
      const prices = this.selectedPrices(
        { id: this.getParentId })
      console.log('selectedTs: prices', prices)
      if (prices !== undefined) {
        if (Object.keys(prices).length === this.modelTickers.length) {
          var tss = new TSS()
          for (const ticker in prices) {
            for (const freq in prices[ticker]) {
              var ts = new TS(prices[ticker][freq])
              // tss[ticker + ':' + freq] = ts
              tss[ticker] = ts
            }
          }
          ts = tss.combine({ discard: false, pad: null })
          console.log('ts', ts)
          return tsfunctions.vami(ts, 100, this.rvDate)
        }
      }
      return null
    },
    isDataReady () {
      const ts = this.selectedTs
      if (ts !== null && ts !== undefined) {
        return !ts.isEmpty()
      } else {
        return false
      }
    },
    maxDate () {
      // for now
      return new Date().toISOString().slice(0, 10)
    }
  },
  methods: {
    ...mapActions({
      setConfig: 'chart/setConfig',
      applyConfigPrices: 'prices/applyConfigPrices'
    }),
    getConfig1 () {
      return this.getConfig({ id: this.getParentId })
    },
    redraw () {
      var config = this.getConfig1({ id: this.getParentId })
      console.log('redraw: config', config)
      config.query.startDate = this.startDate
      config.query.endDate = this.endDate
      this.plotParams.ylabel = this.rvDate + ' = 100'
      console.log('redraw: config after mods', config)
      this.setConfig(config)
      this.applyConfigPrices(config)
    },
    formatTitle (date) {
      const [y, m, d] = date.split('-')
      return `${m} - ${d} - ${y}`
    }
  }
}
</script>

<style scoped>

</style>
